import { useSelector } from 'react-redux'

import { differenceInDays, format } from 'date-fns'

import { RestartAlt } from '@mui/icons-material'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'

import { selectUserConfiguration } from '@/features/domain/user'

import { Tag } from '@workwave-tidal/core/components'
import { Mail } from '@workwave-tidal/core/icons'

import { useResetEmailCounterModal } from '../../modals/ResetNotificationEmailCounter'

import { OutlinedPaperStyle, SecondaryTagStyle } from '../commonStyles'
import { dateFormats } from '../formats'
import { useTexts } from './useTexts'

interface Props {
  emailCount: number
  startDate: Date
}

export function SentEmailsCounter(props: Props) {
  const { emailCount, startDate } = props

  const { Modal: ResetEmailCounterModal, show: showResetEmailCounterModal } =
    useResetEmailCounterModal()

  const texts = useTexts()

  const userConfiguration = useSelector(selectUserConfiguration)
  const date_format = dateFormats[userConfiguration.dateFormat]

  const today = new Date()
  const days = differenceInDays(today, startDate) + 1

  return (
    <>
      <Paper elevation={0} sx={OutlinedPaperStyle} variant="outlined">
        <Stack direction="column" spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body1">
              <Box display="flex" alignItems="center">
                <Mail sx={{ mr: 1 }} />
                {texts.emailsLabel}
              </Box>
            </Typography>

            <Tag
              sx={SecondaryTagStyle}
              label={texts.sentEmails(emailCount.toLocaleString())}
              color="primary"
            />
          </Stack>

          <Typography variant="caption" color="text.secondary">
            {texts.sentEmailsSince(format(startDate, date_format), days)}
          </Typography>

          <Button
            data-testid="reset-email-counter-button"
            data-trackid="reset-email-counter-button"
            onClick={showResetEmailCounterModal}
            startIcon={<RestartAlt />}
            variant="outlined"
          >
            {texts.resetEmailCounter}
          </Button>
        </Stack>
      </Paper>

      <ResetEmailCounterModal />
    </>
  )
}
